import React from "react";
import { SegmentedItem } from "../../../Components/Items";

function SelectorNivelDetalle({ value, onChange, disabled }) {
  return (
    <SegmentedItem
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={[
        { label: "Resumen (1 fila por venta)", value: "cabecera" },
        { label: "Desglosado (1 fila por insumo)", value: "detalle" },
      ]}
    />
  );
}

export default SelectorNivelDetalle;
